import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import PDPMobileStudioPhotoGalleryUI from './PDPMobileStudioPhotoGalleryUI';
const PDPMobileStudioPhotoGalleryInner = t0 => {
  const $ = _c(15);
  const {
    pdpIsModularBYOProduct: t1,
    linkTo,
    mode: t2,
    slug,
    productHeroImage: t3,
    productCylindoHeroImage: t4
  } = t0;
  const pdpIsModularBYOProduct = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const productCylindoHeroImage = t4 === undefined ? null : t4;
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData
  } = usePDPPhotos(null, slug);
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const ssrHeroSrc = productHeroImage?.src || productCylindoHeroImage?.src || null;
  if (photosLoading || basicDetailsLoading || pdpIsModularBYOProduct && modularPhotosData.loading) {
    if (ssrHeroSrc) {
      const t5 = productHeroImage?.alt || productCylindoHeroImage?.alt || "";
      const t6 = productHeroImage?.width || 800;
      const t7 = productHeroImage?.height || 800;
      let t8;
      if ($[0] !== ssrHeroSrc || $[1] !== t5 || $[2] !== t6 || $[3] !== t7) {
        t8 = <RatioContainer><img className="h-full w-full object-contain object-center select-none" src={ssrHeroSrc} alt={t5} width={t6} height={t7} loading="eager" fetchPriority="high" decoding="async" /></RatioContainer>;
        $[0] = ssrHeroSrc;
        $[1] = t5;
        $[2] = t6;
        $[3] = t7;
        $[4] = t8;
      } else {
        t8 = $[4];
      }
      return t8;
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  if (photosError || basicDetailsError) {
    return null;
  }
  const {
    studioPhotos,
    enableCrops,
    introVideoIds
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;
  const {
    name
  } = basicDetailsData;
  const t5 = basicDetailsData?.custom_properties?.campaign;
  const t6 = introVideoIds?.desktop;
  let t7;
  if ($[6] !== enableCrops || $[7] !== linkTo || $[8] !== mode || $[9] !== name || $[10] !== studioPhotos || $[11] !== t5 || $[12] !== t6 || $[13] !== viewGalleryImageEvent) {
    t7 = <PDPMobileStudioPhotoGalleryUI campaign={t5} enableCrops={enableCrops} introVideoId={t6} linkTo={linkTo} mode={mode} photos={studioPhotos} productName={name} viewGalleryImageEvent={viewGalleryImageEvent} />;
    $[6] = enableCrops;
    $[7] = linkTo;
    $[8] = mode;
    $[9] = name;
    $[10] = studioPhotos;
    $[11] = t5;
    $[12] = t6;
    $[13] = viewGalleryImageEvent;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
PDPMobileStudioPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
const PDPMobileStudioPhotoGallery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <ReRenderOnMount><SuspenseWithLoader fallback={t0}><PDPMobileStudioPhotoGalleryInner {...props} /></SuspenseWithLoader></ReRenderOnMount>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobileStudioPhotoGallery;